<template>
  <!-- 视频说法详情页面 -->
  <div class="videoimdet">
    <div class="w12 between">
      <lvbreadcrumb class="speltmbx" :tolist="tolist" />
      <div class="videodetlef">
        <videozw :videoinfo="videoinfo" />
        <videogolawer :list="jinxsplist" />
      </div>
      <div class="videodetrig">
        <detlawbrinfo class="bgff" />
        <detrecomaudio class="mt30 bgff" :list="tjaulist" />
      </div>
    </div>
  </div>
</template>

<script>
import videozw from "./child/videozw";
import videogolawer from "./child/videogolawer";
import detlawbrinfo from "views/articimdet/components/detlawbrinfo";
import detrecomaudio from "./components/detrecomaudio";
import lvbreadcrumb from "components/content/lvbreadcrumb/lvbreadcrumb";

export default {
  components: {
    videozw,
    videogolawer,
    detlawbrinfo,
    detrecomaudio,
    lvbreadcrumb,
  },
  data: () => ({
    videoinfo: {},
    jinxsplist: [],
    tjaulist: [],
  }),
  computed: {
    tolist() {
      return [
        {
          name: "首页",
          path: "/",
        },
        {
          name: "视频说法",
          path: "/laws/videoclaim",
        },
        {
          name: this.videoinfo.title || "",
        },
      ];
    },
  },
  beforeMount() {
    this.getvideoinfo();
    this.getvideolist();
    this.getaudiolist();
  },
  methods: {
    getvideoinfo() {
      let data = {
        id: this.$route.query.videoinId,
      };
      this.$http.laws.getvideocontent(data).then((res) => {
        this.videoinfo = res.data;
      });
    },
    getvideolist() {
      let data = {
        limit: 4,
        order: "hot",
        page: 1,
      };
      this.$http.laws.getvideolist(data).then((res) => {
        this.jinxsplist = res.data.data;
      });
    },

    getaudiolist() {
      let data = {
        limit: 5,
        order: "hot",
        page: 1,
      };
      this.$http.laws.getaudiolist(data).then((res) => {
        this.tjaulist = res.data.data;
      });
    },
  },
  watch: {
    $route(to, from) {
      this.getvideoinfo();
      this.getvideolist();
      this.getaudiolist();
    },
  },
};
</script>

<style lang="scss" scoped>
.videoimdet {
  background-color: #f8f8f8;
  .w12 {
    width: 1200px;
    padding: 50px 0;
    margin: 0 auto;
    align-items: flex-start;
    position: relative;
    .bgff {
      background: #ffffff;
    }
    .videodetlef {
      width: 856px;
      background: #ffffff;
    }
    .videodetrig {
      width: 314px;
    }
  }
  .speltmbx {
    position: absolute;
    top: 20px;
    left: 0;
  }
}
</style>